import classnames from "classnames";
import * as _ from "lodash";
import * as React from "react";
import { MenuItem, Nav, Navbar, NavDropdown, NavItem } from "react-bootstrap";
import { Permissions } from "../shared/model/AllPermissions";
import { Utilities } from "../shared/utilities";
import { getLastReadNotification, getNotificationMessages } from "./actions/AppActions";
import NotificationCenter from "./components/NotificationCenter";
import { initialState, reducer } from "./reducers/AppReducer";
export const releaseNoteStorageKey = "notification/releaseNote";
export const notificationStorageKey = "notification/lastMessages";
export const AppContext = React.createContext(null);
const App = (props) => {
    const [appState, dispatch] = React.useReducer(reducer, initialState);
    const getUriPartsWithoutBase = () => {
        const urlPart = new URL(document.URL).pathname;
        const basePart = new URL(document.baseURI).pathname;
        const urlPartWithoutBase = urlPart.replace(basePart, "").split("/");
        return urlPartWithoutBase;
    };
    const getEnvironmentFromUrl = (activeLink) => {
        const baseUrlParts = getUriPartsWithoutBase();
        let environmentPart = "";
        let agentGroupPart = "";
        switch (activeLink) {
            case LinkNames.process:
            case LinkNames.subprocess:
                if ((baseUrlParts[1] === "List") && baseUrlParts.length >= 3) {
                    environmentPart = "/" + baseUrlParts[2];
                    agentGroupPart = baseUrlParts.length >= 4 ? "/" + baseUrlParts[3] : "";
                }
                break;
            case LinkNames.environmentvariables:
            case LinkNames.monitoringrules:
                if (baseUrlParts.length >= 3) {
                    environmentPart = "/" + baseUrlParts[2];
                }
                break;
            case LinkNames.environment:
            case LinkNames.apimanagement:
                if (baseUrlParts.length >= 2) {
                    environmentPart = "/" + baseUrlParts[1];
                    agentGroupPart = baseUrlParts.length >= 3 ? "/" + baseUrlParts[2] : "";
                }
                break;
            default:
                environmentPart = "";
        }
        return { agentGroupName: agentGroupPart, environmentName: environmentPart };
    };
    const urlParts = getUriPartsWithoutBase();
    const controller = urlParts[0];
    const userRights = Utilities.getAllUserPermissions();
    const getInitialState = () => {
        return {
            base: new URL(document.baseURI).pathname,
            currentAgentGroupEnvironment: getEnvironmentFromUrl(LinkNames[controller.toLowerCase()]),
            hasRightsFor: userRights,
            activeLink: LinkNames[controller.toLowerCase()]
        };
    };
    const [state, setState] = React.useState(getInitialState());
    React.useEffect(() => {
        getNotificationMessages(dispatch, notificationStorageKey);
        getLastReadNotification(dispatch, releaseNoteStorageKey);
        const tick = setInterval(() => {
            const env = getEnvironmentFromUrl(LinkNames[controller.toLowerCase()]);
            if (!_.isEqual(env, state.currentAgentGroupEnvironment)) {
                setState(Object.assign(Object.assign({}, state), { currentAgentGroupEnvironment: env }));
            }
        }, 500);
        return () => clearInterval(tick);
    }, [state.currentAgentGroupEnvironment]);
    const getAuthenticationItems = () => {
        if (props.isAuthenticated === "True") {
            if (props.isSigninsupported === "True") {
                return (React.createElement(NavDropdown, { pullRight: true, id: "signout-dropdown", title: props.username },
                    React.createElement(MenuItem, { href: state.base + "Account/SignOut" }, FRENDS.Localizations.SignOut)));
            }
            else {
                return (React.createElement("li", { role: "presentation" },
                    React.createElement("p", { className: "navbar-text" },
                        React.createElement("span", { className: "glyphicon glyphicon-user" }),
                        " ",
                        props.username)));
            }
        }
        else if (props.isSigninsupported === "True") {
            return (React.createElement(NavItem, { href: state.base + "Account/SignIn" }, FRENDS.Localizations.SignIn));
        }
    };
    const getDropdownMenu = (link, linkIndex) => {
        const menuItems = link.children.map((childLink, childLinkIndex) => {
            if (state.hasRightsFor[childLink.permission]) {
                const linkId = `nav_link_${linkIndex}_${childLinkIndex}`;
                return React.createElement(MenuItem, { id: linkId, key: linkId, className: classnames("dropdown-menu-item menu-item-reversed-padding", { selected: (state.activeLink === childLink.activeLinkName) }), href: generateHref(childLink) }, childLink.label);
            }
            else {
                return null;
            }
        });
        return React.createElement(NavDropdown, { id: "nav_link_" + linkIndex, key: "nav_link_" + linkIndex, eventKey: linkIndex, title: link.label, className: classnames({ active: (link.children.some((x) => x.activeLinkName === state.activeLink)) }) }, menuItems);
    };
    const generateHref = (link) => {
        if (!link.overwriteCurrentEnvironmentInUrl) {
            return state.base + link.href;
        }
        const environment = getEnvironmentFromUrl(LinkNames[controller.toLowerCase()]);
        return state.base + link.href + environment.environmentName + (link.useAgentGroups ? environment.agentGroupName : "");
    };
    return (React.createElement(AppContext.Provider, { value: { appState, dispatch } },
        React.createElement(Navbar, { className: "navbar-static-top" },
            React.createElement(Navbar.Header, null,
                React.createElement(Navbar.Brand, null,
                    React.createElement("a", { href: state.base + "Dashboard" },
                        React.createElement("img", { src: state.base + "Content/Images/frends_logo.svg", width: "150", height: "32" }))),
                React.createElement(Navbar.Toggle, null)),
            React.createElement(Navbar.Collapse, null,
                React.createElement(Nav, { id: "menu" }, navigationBarData.map((link, linkIndex) => (state.hasRightsFor[link.permission] ? (link.children != null
                    ? getDropdownMenu(link, linkIndex)
                    : React.createElement(NavItem, { href: generateHref(link), className: classnames({ active: (state.activeLink === link.activeLinkName) }), key: link.activeLinkName }, link.label)) : null))),
                React.createElement("ul", { className: "nav navbar-nav navbar-right" },
                    React.createElement(NotificationCenter, null),
                    React.createElement(Intercom, { intercomAppId: props.intercomAppId }),
                    getAuthenticationItems())))));
};
const Intercom = ({ intercomAppId }) => {
    if (intercomAppId === "") {
        return (React.createElement(NavItem, { target: "_blank", href: "https://docs.frends.com/" }, FRENDS.Localizations.Help));
    }
    else {
        return (React.createElement(NavItem, { id: "intercom_chat_launcher", href: `mailto:${intercomAppId}@hiq-finland-oy-4347f501d756.intercom-mail.com` },
            React.createElement("i", { className: "fa fa-comment", "aria-hidden": "true" }),
            " ",
            FRENDS.Localizations.Help));
    }
};
var LinkNames;
(function (LinkNames) {
    LinkNames[LinkNames["apimanagement"] = 0] = "apimanagement";
    LinkNames[LinkNames["process"] = 1] = "process";
    LinkNames[LinkNames["subprocess"] = 2] = "subprocess";
    LinkNames[LinkNames["environmentvariables"] = 3] = "environmentvariables";
    LinkNames[LinkNames["administration"] = 4] = "administration";
    LinkNames[LinkNames["environment"] = 5] = "environment";
    LinkNames[LinkNames["task"] = 6] = "task";
    LinkNames[LinkNames["monitoringrules"] = 7] = "monitoringrules";
    LinkNames[LinkNames["usermanagement"] = 8] = "usermanagement";
    LinkNames[LinkNames["apikeymanagement"] = 9] = "apikeymanagement";
    LinkNames[LinkNames["apiaccesspolicymanagement"] = 10] = "apiaccesspolicymanagement";
    LinkNames[LinkNames["settings"] = 11] = "settings";
})(LinkNames || (LinkNames = {}));
const navigationBarData = [
    { href: "ApiManagement", activeLinkName: LinkNames.apimanagement, label: FRENDS.Localizations.ApiManagement, permission: Permissions.ApiManagementView, overwriteCurrentEnvironmentInUrl: true, useAgentGroups: true },
    { href: "Process/List", activeLinkName: LinkNames.process, label: FRENDS.Localizations.Processes, permission: Permissions.ProcessView, overwriteCurrentEnvironmentInUrl: true, useAgentGroups: true },
    { href: "SubProcess/List", activeLinkName: LinkNames.subprocess, label: FRENDS.Localizations.Subprocesses, permission: Permissions.SubProcessEdit, overwriteCurrentEnvironmentInUrl: true, useAgentGroups: true },
    { href: "EnvironmentVariables/List", activeLinkName: LinkNames.environmentvariables, label: FRENDS.Localizations.EnvironmentVariables, permission: Permissions.EnvironmentVariablesEdit, overwriteCurrentEnvironmentInUrl: true },
    {
        href: "", activeLinkName: LinkNames.administration, label: FRENDS.Localizations.Administration, permission: Permissions.AdministrationView, overwriteCurrentEnvironmentInUrl: false,
        children: [
            { href: "Environment", activeLinkName: LinkNames.environment, label: FRENDS.Localizations.Environments, permission: Permissions.EnvironmentEdit, overwriteCurrentEnvironmentInUrl: true, useAgentGroups: true },
            { href: "Task", activeLinkName: LinkNames.task, label: FRENDS.Localizations.Tasks, permission: Permissions.TaskView, overwriteCurrentEnvironmentInUrl: false },
            { href: "MonitoringRules/List", activeLinkName: LinkNames.monitoringrules, label: FRENDS.Localizations.MonitoringRules, permission: Permissions.MonitoringRulesView, overwriteCurrentEnvironmentInUrl: true },
            { href: "UserManagement", activeLinkName: LinkNames.usermanagement, label: FRENDS.Localizations.UserManagement, permission: Permissions.UserManagementAdmin, overwriteCurrentEnvironmentInUrl: false },
            { href: "ApiKeyManagement", activeLinkName: LinkNames.apikeymanagement, label: FRENDS.Localizations.Administration_ApiKeys, permission: Permissions.ApiKeyManagementAdmin, overwriteCurrentEnvironmentInUrl: false },
            { href: "ApiAccessPolicyManagement", activeLinkName: LinkNames.apiaccesspolicymanagement, label: FRENDS.Localizations.ApiAccessPolicies, permission: Permissions.ApiAccessPolicyManagementAdmin, overwriteCurrentEnvironmentInUrl: false },
            { href: "Settings", activeLinkName: LinkNames.settings, label: FRENDS.Localizations.Settings, permission: Permissions.SettingsAdmin, overwriteCurrentEnvironmentInUrl: false }
        ]
    }
];
export default App;
